import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/card-1.jpg'


const _hoisted_1 = {
  class: "tab-content",
  id: "myTab5Content"
}
const _hoisted_2 = {
  class: "tab-pane fade",
  id: "code5-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "code5-tab",
  tabindex: "0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[3] || (_cache[3] = _createElementVNode("ul", {
      class: "nav nav-tabs mb-4 bg-white",
      id: "myTab5",
      role: "tablist"
    }, [
      _createElementVNode("li", {
        class: "nav-item",
        role: "presentation"
      }, [
        _createElementVNode("button", {
          class: "nav-link active",
          id: "preview5-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#preview5-tab-pane",
          type: "button",
          role: "tab",
          "aria-controls": "preview5-tab-pane",
          "aria-selected": "true"
        }, " Preview ")
      ]),
      _createElementVNode("li", {
        class: "nav-item",
        role: "presentation"
      }, [
        _createElementVNode("button", {
          class: "nav-link",
          id: "code5-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#code5-tab-pane",
          type: "button",
          role: "tab",
          "aria-controls": "code5-tab-pane",
          "aria-selected": "false"
        }, " Code ")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "tab-pane fade show active",
        id: "preview5-tab-pane",
        role: "tabpanel",
        "aria-labelledby": "preview5-tab",
        tabindex: "0"
      }, [
        _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
          _createElementVNode("div", { class: "card-body p-4" }, [
            _createElementVNode("div", { class: "mb-4" }, [
              _createElementVNode("span", { class: "badge bg-primary bg-opacity-50 rounded-1 text-dark py-2 px-3 me-1 fs-13 fw-medium" }, "Primary"),
              _createElementVNode("span", { class: "badge bg-warning bg-opacity-50 rounded-1 text-dark py-2 px-3 me-1 fs-13 fw-medium" }, "Warning"),
              _createElementVNode("span", { class: "badge bg-success bg-opacity-50 rounded-1 text-dark py-2 px-3 me-1 fs-13 fw-medium" }, "Success")
            ]),
            _createElementVNode("img", {
              src: _imports_0,
              class: "mb-4 rounded-3",
              alt: "card"
            }),
            _createElementVNode("h3", { class: "mb-3 fs-16 fw-semibold" }, "Nesta Technologies"),
            _createElementVNode("p", { class: "mb-20" }, " When you enter into any new area of science, you almost always find. "),
            _createElementVNode("a", {
              href: "#",
              class: "btn btn-primary py-2 px-4 bg-primary bg-opacity-10 fw-semibold text-primary border-0 hover-bg"
            }, " View Details ")
          ])
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0 mt-5",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyCode && _ctx.copyCode(...args)))
        }, " Copy "),
        _cache[1] || (_cache[1] = _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
          _createTextVNode(""),
          _createElementVNode("code", {
            class: "language-markup",
            id: "codeCopy"
          }, "\n<div class=\"card bg-white border-0 rounded-3 mb-4\">\n<div class=\"card-body p-4\">\n<div class=\"mb-4\">\n<span class=\"badge bg-primary bg-opacity-50 rounded-1 text-dark py-2 px-3 fs-13 fw-medium\">Primary</span>\n<span class=\"badge bg-success bg-opacity-50 rounded-1 text-dark py-2 px-3 fs-13 fw-medium\">Success</span>\n</div>\n<img src=\"@/assets/images/card-1.jpg\" class=\"mb-4 rounded-3\" alt=\"card\">\n<h3 class=\"mb-3 fs-16 fw-semibold\">Nesta Technologies</h3>\n<p class=\"mb-20\">When you enter into any new area of science, you almost always find.</p>\n<a href=\"#\" class=\"btn btn-primary py-2 px-4 bg-primary bg-opacity-10 fw-semibold text-primary border-0 hover-bg\">\nView Details\n</a>\n</div>\n</div>\n"),
          _createTextVNode("\n")
        ], -1))
      ])
    ])
  ], 64))
}